import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-footer-contract-list',
  templateUrl: './footer-contract-list.component.html',
  styleUrls: ['./footer-contract-list.component.scss']
})
export class FooterContractListComponent {
  @Output() addContractsEvent = new EventEmitter();
  @Output() closeModalEvent = new EventEmitter();

  constructor() {}
}
